import { render } from "./SeoLinkHub.vue?vue&type=template&id=66d22c50&scoped=true"
import script from "./SeoLinkHub.vue?vue&type=script&lang=js"
export * from "./SeoLinkHub.vue?vue&type=script&lang=js"

import "./SeoLinkHub.vue?vue&type=style&index=0&id=66d22c50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d22c50"]])

export default __exports__